import React from 'react';
import { useTranslation } from 'react-i18next';

import RequestRow from './RequestRow.react';

const ActiveRequestSection = ({ request, currency, onOpenRequest }) => {
    const { t } = useTranslation('CashWallet');

    return (
        <div className="cash-wallet-active-section">
            <div className="cash-wallet-section-title">{t('Requests.ActiveTitle')}</div>
            <div className="cash-wallet-active-helper">{t('Requests.ActiveHelper')}</div>
            <div className="cash-wallet-request-rows">
                <RequestRow request={request} currency={currency} onOpen={onOpenRequest} />
            </div>
        </div>
    );
};

export default ActiveRequestSection;
